module.exports = __webpack_public_path__ + "img/2018-09-2.5f971519.jpeg";